"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var alwaysDeleteConversationsService_1 = require("../services/alwaysDeleteConversationsService");
var createSweepRuleForSenderService_1 = require("../services/createSweepRuleForSenderService");
var owa_mail_sweep_store_1 = require("owa-mail-sweep-store");
var folderNameToId_1 = require("owa-session-store/lib/utils/folderNameToId");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * The keepNParametersTable is used to hold the keepN parameters that used for
 * ApplyBulkItemAction and CreateSweepRuleForSenderAction
 */
var keepNParametersTable = {};
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.All] = { keepNType: 1 /* Items */, keepNCount: 0 };
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.AllCurrentAndFuture] = {
    keepNType: 1 /* Items */,
    keepNCount: 0,
};
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.AllButOne] = { keepNType: 1 /* Items */, keepNCount: 1 };
keepNParametersTable[owa_mail_sweep_store_1.SweepOptionType.AllOlderThan] = { keepNType: 0 /* Days */, keepNCount: 10 };
/**
 * Get the keep n parameters from the table
 * @param sweepOptionType the sweep option type
 */
function getKeepNParameters(sweepOptionType) {
    return keepNParametersTable[sweepOptionType];
}
/**
 * Perform the sweep conversations action
 * @param sweepableMailboxes the sweepable mailboxes (ie not your own mailbox)
 * @param tableView the table view
 * @param sweepOptionType the sweep option type
 */
exports.default = legacy_1.action('sweepConversations')(function sweepConversations(sweepableMailboxes, tableView, sweepOptionType) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, keepNType, keepNCount, destinationFolderId, sourceFolderId;
        return tslib_1.__generator(this, function (_b) {
            _a = getKeepNParameters(sweepOptionType), keepNType = _a.keepNType, keepNCount = _a.keepNCount;
            destinationFolderId = folderNameToId_1.default('deleteditems');
            sourceFolderId = tableView.tableQuery.folderId;
            alwaysDeleteConversationsService_1.default(sweepableMailboxes, destinationFolderId, sourceFolderId, keepNType, keepNCount);
            if (sweepOptionType == owa_mail_sweep_store_1.SweepOptionType.All) {
                // No sweep rule needs to be created if sweep operation is to delete all emails from a sender.
                // In that case, just dismiss the dialog
                return [2 /*return*/];
            }
            else {
                // Show 'Creating...' dialog
                owa_mail_sweep_store_1.setSweepRequestStatus(1 /* Pending */);
            }
            return [2 /*return*/, createSweepRuleForSenderService_1.default(sweepableMailboxes, destinationFolderId, sourceFolderId, keepNType, keepNCount)
                    .then(function (response) {
                    if (response.ResponseMessages.Items[0].ResponseClass == 'Success') {
                        // Show complete dialog if request succeeds
                        owa_mail_sweep_store_1.setSweepRequestStatus(2 /* Complete */);
                    }
                })
                    .catch(function () {
                    // Show error dialog if request fails
                    owa_mail_sweep_store_1.setSweepRequestStatus(3 /* Error */);
                })];
        });
    });
});
//# sourceMappingURL=sweepConversations.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/sweepConversations.js
// module id = 5642
// module chunks = 62